export const AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION =
  'dev.azure.com/build-definition';
export const AZURE_DEVOPS_HOST_ORG_ANNOTATION = 'dev.azure.com/host-org';
export const AZURE_DEVOPS_PROJECT_ANNOTATION = 'dev.azure.com/project';
export const AZURE_DEVOPS_PROJECT_REPO_ANNOTATION =
  'dev.azure.com/project-repo';
export const AZURE_DEVOPS_README_PATH_ANNOTATION = 'dev.azure.com/readme-path';

export const GITHUB_PROJECT_README_PATH_ANNOTATION =
  'github.com/project-readme-path';
export const GITHUB_PROJECT_SLUG_ANNOTATION = 'github.com/project-slug';

export const GITLAB_CODEOWNERS_PATH_ANNOTATION = 'gitlab.com/codeowners-path';
export const GITLAB_INSTANCE_ANNOTATION = 'gitlab.com/instance';
export const GITLAB_PROJECT_ID_ANNOTATION = 'gitlab.com/project-id';
export const GITLAB_PROJECT_SLUG_ANNOTATION = 'gitlab.com/project-slug';
export const GITLAB_README_PATH_ANNOTATION = 'gitlab.com/readme-path';
